export default class UploadFileUtils {
  constructor() {

  }

  //获取图片后缀
  getSuffix(fileName) {
    if (fileName.indexOf('.jpg')) {
      return '.jpg'
    }
    if (fileName.indexOf('.jpeg')) {
      return '.jpeg'
    }
    if (fileName.indexOf('.png')) {
      return '.png'
    }
  }

  //判断文件目录曾经，固定为二级或三级
  checkImgDir(files) {
    let flag = true
    let myFiles = []
    for (let file of files) {
      let isDelete=false
      let fs=file.name.split('.')
      if(fs.length>2){
        if(fs[0]==''){
          isDelete=true
        }
      }
      if (isDelete==false) {

        if (file.name.indexOf('.jpg') > -1 ||file.name.indexOf('.JPG') > -1 ||file.name.indexOf('.PNG') > -1 ||file.name.indexOf('.JPEG') > -1 || file.name.indexOf('.jpeg') > -1 || file.name.indexOf('.png') > -1) {
          let webkitRelativePath = file.webkitRelativePath
          let pathLength = webkitRelativePath.split('/').length
          if (pathLength == 2 || pathLength == 3) {
            if (pathLength == 3) {
              file.length = 3
              myFiles.push(file)
            } else {
              file.length = 2
              myFiles.push(file)
            }
          } else {
            flag = false
            return { flag, flag, files: myFiles }
          }
        }
      }
    }

    return { flag: flag, files: myFiles }
  }
  //归位，files
  resetFilesSort(files, file3) {
    let myFiles = []
    let otherFilesArray = []
    for (let file of files) {
      if (otherFilesArray.includes(file.webkitRelativePath) == true) {
        continue
      }
      if (file.length == 3) {
        file.otherFiles = file3.find(item => item.findIndex(each => each.webkitRelativePath === file.webkitRelativePath) > -1)
        let others = file.otherFiles.map(item => item.webkitRelativePath)
        otherFilesArray = otherFilesArray.concat(others)
      }

      myFiles.push(file)
    }
    return myFiles
  }
}


// WEBPACK FOOTER //
// ./src/main/admin/UploadFileUtils.js